<script setup lang="ts">
import { onMounted } from 'vue'
import Glide, { Autoplay, Controls } from '@glidejs/glide/dist/glide.modular.esm'
import { ArrowDownIcon } from '@heroicons/vue/24/outline/index.js'

import * as Slides from '~/assets/slider'
import { LogoBaselineWhite } from '~/assets/logos'

onMounted(() => {
  new Glide('.glide', {
    type: 'carousel',
    gap: 0,
    autoplay: 7500,
    perView: 1,
    hoverpause: false,
    animationDuration: 0,
  }).mount({ Controls, Autoplay })
})
</script>

<template>
  <section class="relative overflow-hidden">
    <div id="banner"
         class="relative sm:absolute bg-black/50 z-10 flex flex-col items-center inset-0 z-10 flex py-12 text-white justify-center"
    >
      <div class="relative text-center mx-4 pb-12">
        <div class="text-center mb-4">
          <span class="text-xl text-gray-100">
            {{ $t('pages.index.banner.suptitle') }}
          </span>
          <h1 class="sr-only">
            {{ $t('project.name') }}
          </h1>
        </div>
        <img :src="LogoBaselineWhite"
             alt="Logo El Cónsul Maó"
             width="160"
             height="auto"
             class="sm:w-48 inline-block"
        >
      </div>
      <a class="hidden sm:block absolute bottom-0 left-1/2 -translate-x-1/2 py-4 text-white animate-bounce"
         aria-label="Scroll down"
         href="#content"
      >
        <ArrowDownIcon class="h-10 w-10"
                       aria-hidden="true"
        />
      </a>
    </div>
    <div class="absolute inset-0 sm:hidden">
      <img :src="Slides.Slide1" alt="Slider 1" class="object-cover h-full w-full">
    </div>
    <div class="hidden sm:block glide">
      <div class="glide__track" data-glide-el="track">
        <div id="slider" class="glide__slides relative min-h-[560px]">
          <div v-for="(slide, idx) in Object.values(Slides)"
               :key="idx"
               class="glide__slide inset-0 absolute"
          >
            <img :src="slide" alt="" class="object-cover h-full w-full">
          </div>
        </div>
      </div>
      <div class="hidden md:flex z-20 glide__bullets absolute right-0 top-1/2 -translate-y-1/2 flex-col items-center justify-center pr-6 space-y-4"
           data-glide-el="controls[nav]"
      >
        <span v-for="(_, idx) in Object.values(Slides)"
              :key="idx"
              class="glide__bullet rounded-full border border-white transition h-3 w-3 cursor-pointer hover:bg-white hover:bg-opacity-40"
              :data-glide-dir="`=${idx}`"
        />
      </div>
    </div>
  </section>
</template>

<style>
#slider {
  height: calc(100vh - 175px)
}

@screen lg {
  #slider {
    height: calc(100vh - 120px)
  }
}

.glide__slides {
  transform: translate3d(0, 0, 0)!important;
  width: 100vw!important;
}
.glide__slide {
  width: 100% !important;
  opacity: 0;
  z-index: 0;
  transition: opacity 1.5s ease-in-out;
  animation: zoom-in-zoom-out 15s ease infinite;
}

.glide__slide.glide__slide--active {
  opacity: 1;
  z-index: 1;
  transition: opacity 1.5s ease-in-out;
}

.glide__bullet.glide__bullet--active {
  background: #FFF !important;
}

@keyframes zoom-in-zoom-out {
  0% {
    transform: scale(1, 1);
  }
  50% {
    transform: scale(1.1, 1.1);
  }
  100% {
    transform: scale(1, 1);
  }
}
</style>
